import { render, staticRenderFns } from "./Empresa-tab-contato.vue?vue&type=template&id=07c2bd02&scoped=true&"
import script from "./Empresa-tab-contato.vue?vue&type=script&lang=js&"
export * from "./Empresa-tab-contato.vue?vue&type=script&lang=js&"
import style0 from "./Empresa-tab-contato.vue?vue&type=style&index=0&id=07c2bd02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2bd02",
  null
  
)

export default component.exports